import React, { useEffect, useMemo, useState } from 'react';
import { Col, Row } from 'antd';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';

import Information from './component/Information';
import Revenue from './component/Revenue';
import Payment from './component/Payment';
import { LoadingContainer } from 'app/components/LoadingContainer';
import {
  GET_ACC_BELONG_AGENT,
  GET_BUSINESS_PARTNER,
} from 'app/pages/App/slice';
import {
  selectAccListBelongAgent,
  selectBusinessPartner,
  selectInfoUser,
} from 'app/pages/App/slice/selectors';
import useWindowSize from 'app/hooks/useWindowSize';
import useFetchData from 'app/hooks/useFetchData';
import { getTransactionHistoryApi } from 'app/services/agentApi';
import { BP_TYPE } from 'utils/constants';
import { momentTz } from '../TransactionHistoryOverview';
import { TYPE_REPORT } from '../TransactionHistoryOverview/components/Filter';
import Contract from './component/Contract';

const AgentInfo = () => {
  const [monthFilter, setMonthFilter] = useState(moment());

  const { loading: loadingBusinessPartnerDetail } = useSelector(
    selectBusinessPartner,
  );

  const { loading: loadingAccListBelongAgent } = useSelector(
    selectAccListBelongAgent,
  );

  const userInfo = useSelector(selectInfoUser);
  const isProxyBuyer =
    (userInfo?.businessPartner as any)?.bpType === BP_TYPE.PROXY_BUYER;

  const dispatch = useDispatch();

  const { windowSize } = useWindowSize();

  const getTransactionParams = useMemo(
    () => ({
      dateFrom: momentTz.clone().startOf('month').format('DD/MM/YYYY'),
      dateTo: momentTz.clone().format('DD/MM/YYYY'),
      page: 1,
      limit: 1,
      typeReport: TYPE_REPORT.OVERVIEW,
    }),
    [],
  );

  const { result: transactionHistory, isLoading: isLoadingTransactionHistory } =
    useFetchData({
      actionApi: getTransactionHistoryApi,
      payloadData: getTransactionParams,
    });

  useEffect(() => {
    const getBusinessParter = () => {
      dispatch(GET_BUSINESS_PARTNER());
    };
    const getAccListBelongAgent = () => {
      dispatch(GET_ACC_BELONG_AGENT());
    };

    getBusinessParter();
    getAccListBelongAgent();
  }, [dispatch]);

  return (
    <LoadingContainer
      loading={loadingBusinessPartnerDetail || loadingAccListBelongAgent}
    >
      <Container>
        <Row gutter={[25, 25]}>
          <Col span={windowSize.width < 992 ? 24 : 12}>
            <Information />
          </Col>
          <Col span={windowSize.width < 992 ? 24 : 12}>
            <Row style={{ flexDirection: 'column' }} gutter={[25, 25]}>
              <Col>
                <Revenue
                  monthFilter={monthFilter}
                  setMonthFilter={setMonthFilter}
                />
              </Col>
              {!isProxyBuyer && (
                <Col>
                  <Payment
                    transactionData={
                      isLoadingTransactionHistory ? null : transactionHistory
                    }
                  />
                </Col>
              )}
              <Col>
                <Contract
                  transactionData={
                    isLoadingTransactionHistory ? null : transactionHistory
                  }
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </LoadingContainer>
  );
};

export default AgentInfo;

const Container = styled.div``;

export const Title = styled.h4`
  font-size: 20px;
  line-height: 40px;
  color: #000000;
  font-weight: 600;
  margin: 0;
  text-transform: uppercase;
`;

export const Block = styled.div`
  border-radius: 20px;
  padding: 32px;
  background: #ffffff;
  box-shadow: 0px 20px 20px 0px #0000000d;
  &.list-account {
    margin-top: 25px;
    padding: 22px 32px 46px;
  }
`;
